import styled from "styled-components";

export const PageLoadingDiv = styled.div`
  height: 100vh;
  width: 100%;
  background: var(--atlantico);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
